import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import getIsInitializingCart from '@core/reducers/cart/selectors/getIsInitializingCart';
import getCartHasLocation from '@core/reducers/cart/selectors/getCartHasLocation';
import getHasCart from '@core/reducers/cart/selectors/getHasCart';
import getFromOrderId from '@core/reducers/cart/selectors/getFromOrderId';
import getSearchedLocation from '@location/selectors/getSearchedLocation';
import changeAddress from '@core/reducers/cart/actions/changeAddress';
import setSearchedLocation from '@location/actions/setSearchedLocation';
import getCart from '@core/reducers/cart/selectors/getCart';
import getShopName from '@core/reducers/shop/selectors/getShopName';
import getShop from '@core/reducers/shop/selectors/getShop';
import getShowNoLocationPointToast from '@shopDetails/selectors/getShowNoLocationPointToast';
import closeNoLocationPointToast from '@shopDetails/actions/closeNoLocationPointToast';
import initializeCart from '@core/reducers/cart/actions/initCart';
import navigateToShopsListAfterOutOfDelivery from '@checkout/actions/navigateToShopsListAfterOutOfDelivery';
import getIsOutOfDeliveryError from '@core/reducers/cart/selectors/getIsOutOfDeliveryError';
import resetOutOfDeliveryError from '@core/reducers/cart/actions/resetOutOfDeliveryError';

import LocationFlowManager from '@location/HOCs/LocationFlowManager';
import { getIsDesktopLayout } from '@shared/selectors';
import getBusinessTypeFromQuery from '@shared/selectors/getBusinessTypeFromQuery';
import getShouldShowLocationPointToast from '@productConfig/selectors/getShouldShowLocationPointToast';
import WithOnBeforeProductConfig from './WithOnBeforeProductConfig';

const mapStateToProps = createStructuredSelector({
  cartHasLocation: getCartHasLocation,
  hasCart: getHasCart,
  cartFromOrderId: getFromOrderId,
  isInitializingCart: getIsInitializingCart,
  showNoLocationPointToast: getShowNoLocationPointToast,
  isShowingOutOfDeliveryError: getIsOutOfDeliveryError,
  shop: getShop,
  cart: getCart,
  searchedLocation: getSearchedLocation,
  shopName: getShopName,
  isDesktopLayout: getIsDesktopLayout,
  businessTypeFromQuery: getBusinessTypeFromQuery,
  shouldShowLocationPointToast: getShouldShowLocationPointToast,
});

const mapDispatchToProps = {
  setSearchedLocation,
  closeNoLocationPointToast,
  initializeCart,
  onChangeAddress: changeAddress,
  navigateToShopsListAfterOutOfDelivery,
  resetOutOfDeliveryError,
};

const withLocationFlowManager = T => LocationFlowManager(T, { unmount: false });

export default compose(
  withLocationFlowManager,
  connect(mapStateToProps, mapDispatchToProps),
  WithOnBeforeProductConfig,
);
